var _g, _circle, _circle2, _g2, _path, _circle3, _g3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstEventRvsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 154,
    viewBox: "0 0 237 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Award 2",
    filter: "url(#filter0_d_3333_31276)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 41",
    d: "M41.0137 1C41.0137 1 73.2194 15.4619 114.195 15.4619C155.17 15.4619 183.67 1 183.67 1V58.0746H41.0137V1Z",
    fill: "#1E588E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 42",
    d: "M41.0137 4.85742C41.0137 4.85742 73.2194 19.3193 114.195 19.3193C155.17 19.3193 183.67 4.85742 183.67 4.85742V61.932H41.0137V4.85742Z",
    fill: "#243560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25",
    d: "M103.846 48.6406L63.3755 107.984L1.00023 60.3426L21.2353 30.6708L41.4704 0.999122L103.846 48.6406Z",
    fill: "#2874BA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.223 48.6415L162.693 107.985L225.068 60.3434L184.598 1L122.223 48.6415Z",
    fill: "#2874BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.068 60.3434L162.693 107.985L159.51 103.317L219.005 57.8753L225.068 60.3434Z",
    fill: "#2874BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.598 1L122.223 48.6415L125.406 53.309L184.901 7.86688L184.598 1Z",
    fill: "#2874BA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 28",
    d: "M107.639 52.2031L67.1685 111.547L4.7932 63.9051L25.0283 34.2333L45.2634 4.56162L107.639 52.2031Z",
    fill: "#2D4071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 30",
    d: "M120.92 57.1309L154.669 106.619L217.045 58.9778L200.17 34.2336L183.295 9.48936L120.92 57.1309Z",
    fill: "#2D4071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M1.00025 60.3443L63.3755 107.986L66.5586 103.318L7.06286 57.8762L1.00025 60.3443Z",
    fill: "#2874BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 27",
    d: "M41.4699 0.999629L103.845 48.6411L100.662 53.3086L41.1664 7.86647L41.4699 0.999629Z",
    fill: "#2874BA"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 113.23,
    cy: 81.2321,
    r: 60.2399,
    fill: "#FFDE69",
    stroke: "#6E5600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3333_31276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 41,
    width: 92,
    height: 91
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 115.811,
    cy: 86.7133,
    r: 45.2836,
    fill: "#C28B37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3333_31276)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 113.399,
    cy: 81.8911,
    r: 45.2836,
    fill: "#C09525"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3_2",
    d: "M113.712 127.071C139.182 127.071 160.032 107.09 160.032 82.1977C160.032 57.3054 139.182 37.3245 113.712 37.3245C88.2421 37.3245 67.3928 57.3054 67.3928 82.1977C67.3928 107.09 88.2421 127.071 113.712 127.071Z",
    fill: "#6F5600",
    stroke: "#D1A635",
    strokeWidth: 6.83155
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3333_31276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 44,
    width: 85,
    height: 85
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4_2",
    cx: 115.692,
    cy: 86.5392,
    r: 41.9357,
    fill: "#C28B37"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3333_31276)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3_3",
    cx: 113.459,
    cy: 82.0724,
    r: 41.9357,
    fill: "#936A00"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M113.713 49.6741L124.232 70.1207L124.475 70.592L125.001 70.6559L145.887 73.193L131.534 88.8336L131.202 89.1962L131.286 89.681L135.211 112.26L114.15 102.026L113.713 101.814L113.276 102.026L92.2181 112.258L96.1774 89.6824L96.2627 89.1961L95.9285 88.8327L81.542 73.1927L102.425 70.6559L102.951 70.592L103.193 70.1207L113.713 49.6741Z",
    fill: "url(#paint0_linear_3333_31276)",
    stroke: "#7E6200",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3333_31276",
    x: 0.216502,
    y: 0.216502,
    width: 236.604,
    height: 153.509,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3333_31276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3333_31276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3333_31276",
    x1: 113.713,
    y1: 47.4883,
    x2: 113.713,
    y2: 114.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE178"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstEventRvsp);
export default __webpack_public_path__ + "static/media/First_Event_RVSP.de7a980e2d035fb97c8f53fe34101291.svg";
export { ForwardRef as ReactComponent };